export const addScript = () => {
  let scriptEl = document.createElement('script');
  scriptEl.innerText = `
  window.channelPluginSettings = {
    pluginKey: '4a46679e-e526-4ba5-a18b-a710a3ddcdae',
    customLauncherSelector: '.channelIoButton btn',
    "hideDefaultLauncher": true
  };
  (function() {
    var w = window;
    if (w.ChannelIO) {
      return (window.console.error || window.console.log || function() {})(
        'ChannelIO script included twice.',
      );
    }
    var d = window.document;
    var ch = function() {
      ch.c(arguments);
    };
    ch.q = [];
    ch.c = function(args) {
      ch.q.push(args);
    };
    w.ChannelIO = ch;
    function l() {
      if (w.ChannelIOInitialized) {
        return;
      }
      w.ChannelIOInitialized = true;
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
      s.charset = 'UTF-8';
      var x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }
    if (document.readyState === 'complete') {
      l();
    } else if (window.attachEvent) {
      window.attachEvent('onload', l);
    } else {
      window.addEventListener('DOMContentLoaded', l, false);
      window.addEventListener('load', l, false);
    }
  })();`;

  const body = document.getElementsByTagName('body');
  body[0].appendChild(scriptEl);
};

export const trigger = e => {
  e.preventDefault();
  const el = document.getElementsByClassName('textLauncherIcon');
  const event = document.createEvent('Event');
  event.initEvent('click', true, true);
  console.log();
  if (el[0]) el[0].dispatchEvent(event);
};
